import {
  AdditionalMessageField, AdditionalMessageFieldTypes
} from '@models/adminstration/machine/trigger/trigger-query/additional-message-field/additional-message-field';
import {TRIGGER_SIGNAL_TYPE} from '@constants/administration/machine/trigger-signal-label';

export const ARGOS_EVENT_FIELDS: AdditionalMessageField[] = [
  {
    fieldName: AdditionalMessageFieldTypes.EventCodeUniversal,
    dataType: 'number',
    value: 0
  },
  {
    fieldName: AdditionalMessageFieldTypes.EventCodeNative,
    dataType: 'number',
    value: 0
  },
  {
    fieldName: AdditionalMessageFieldTypes.EventCreated,
    dataType: 'boolean',
    value: false
  },
  {
    fieldName: AdditionalMessageFieldTypes.EventSeverity,
    dataType: 'eventSeverity',
    value: TRIGGER_SIGNAL_TYPE.ERROR
  },
  {
    fieldName: AdditionalMessageFieldTypes.AdditionalInformation,
    dataType: 'string',
    value: ''
  },
  {
    fieldName: AdditionalMessageFieldTypes.EventDescription,
    dataType: 'string',
    value: ''
  },
];
